import { ApiError } from '@/api/http';

export function inviteDetailsAlertKey(
  error: unknown,
): 'EXPIRED_LINK_ERROR' | 'ERROR_SOMETHING_WENT_WRONG' {
  if (error instanceof ApiError && error.status === 404) {
    return 'EXPIRED_LINK_ERROR';
  }
  return 'ERROR_SOMETHING_WENT_WRONG';
}
